import { API_URL } from './urls';

export const makeTemplatesClient = r => ({
  loadTasklists: () => r(`${API_URL}tasklists/`),
  createTasklist: data => r(`${API_URL}tasklists/`, 'post', data),
  deleteTasklist: id => r(`${API_URL}tasklists/${id}/`, 'delete'),
  updateTasklist: (id, data) => r(`${API_URL}tasklists/${id}/`, 'patch', data)
});
